module.exports = __webpack_public_path__ + "efbbd85825fc29be45e89abc1cafbf3b.pdf";